import tw from "twin.macro";

export const Container = tw.div`relative`;
export const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto pt-20 lg:pt-20 pb-0`;
export const ContentWithPaddingLg = tw.div`max-w-screen-lg mx-auto pt-20 lg:pt-20 pb-0`;
export const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
export const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;
